import React from 'react';
import { SunIcon, MoonIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export const ThemeToggle = () => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="p-2 rounded-full transition-colors hover:bg-background-neutral-soft dark:hover:bg-dark-background-neutral-soft" aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-104">
      {theme === 'dark' ? <SunIcon className="w-5 h-5 text-dark-text" data-id="element-105" /> : <MoonIcon className="w-5 h-5 text-text" data-id="element-106" />}
    </button>;
};